import React, { useEffect, useState } from "react";
import styles from "../styles/Pricing.module.css";
import useApi from "../hooks/useApi";
// import {
//   PaymentElement,
//   Elements,
//   useStripe,
//   useElements,
// } from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";

const PricingToggle = ({ isAnnual, onToggle }) => {
  return (
    <div className={styles.pricingToggle}>
      <span className={!isAnnual ? styles.active : ""}>Monthly</span>

      <label className={styles.switch}>
        <input type="checkbox" checked={isAnnual} onChange={onToggle} />
        <span className={styles.slider}></span>
      </label>

      <span className={isAnnual ? styles.active : ""}>Yearly - 20% off</span>
    </div>
  );
};

const PricingCard = ({ title, price, credits, benefits, onClick }) => {
  return (
    <div className={styles.pricingCard}>
      <h5>{title}</h5>
      <p>{price}</p>
      <p className={styles.credits}>Inclues {`${credits}`} Credits monthly</p>

      <button className={styles.buyPlan} onClick={onClick}>
        Change Plan
      </button>

      <ul className={styles.credits}>
        {benefits.map((benefit, index) => (
          <li key={index}>{benefit}</li>
        ))}
      </ul>
    </div>
  );
};

const initialPlansDescription = [
  {
    name: "Basic",
    monthly: "$0",
    annual: "$0",
    monthly_id: "",
    annual_id: "",
    credits: 60,
    benefits: [
      `\u2713 Generative Video Gen-3 Alpha`,
      `\u2713 Upscale resolution Gen-1, Gen-2`,
      `\u2713 Remove watermarks Gen-1, Gen2, Gen-3 Alpha`,
      `\u2713 Credits refresh monthly`,
      `\u2713 No rate restrictions`,
      `\u2713 Buy more credits`,
      `\u2713 Train custom IA`,
      `\u2713 1 complimentary training`,
      `\u2713 100GB Assets storage`,
      `\u2713 Unlimited video projects`,
      `\u2713 720p/4K/Alpha Matte Video project exports`,
      `\u2713 Technical support via Runway dashboard`,
    ],
  },
  {
    name: "Standard",
    monthly: "",
    annual: "",
    monthly_id: "",
    annual_id: "",
    credits: 600,
    benefits: [
      `Everything in Basic and...`,
      `\u2713 Generative Video Gen-3 Alpha`,
      `\u2713 Upscale resolution Gen-1, Gen-2`,
      `\u2713 Remove watermarks Gen-1, Gen2, Gen-3 Alpha`,
      `\u2713 Credits refresh monthly`,
      `\u2713 No rate restrictions`,
      `\u2713 Buy more credits`,
      `\u2713 Train custom IA`,
      `\u2713 1 complimentary training`,
      `\u2713 100GB Assets storage`,
      `\u2713 Unlimited video projects`,
      `\u2713 720p/4K/Alpha Matte Video project exports`,
      `\u2713 Technical support via Runway dashboard`,
    ],
  },
  {
    name: "Pro",
    monthly: "",
    annual: "",
    monthly_id: "",
    annual_id: "",
    credits: 1200,
    benefits: [
      `Everything in Standard and...`,
      `\u2713 Generative Video Gen-3 Alpha`,
      `\u2713 Upscale resolution Gen-1, Gen-2`,
      `\u2713 Remove watermarks Gen-1, Gen2, Gen-3 Alpha`,
      `\u2713 Credits refresh monthly`,
      `\u2713 No rate restrictions`,
      `\u2713 Buy more credits`,
      `\u2713 Train custom IA`,
      `\u2713 1 complimentary training`,
      `\u2713 100GB Assets storage`,
      `\u2713 Unlimited video projects`,
      `\u2713 720p/4K/Alpha Matte Video project exports`,
      `\u2713 Technical support via Runway dashboard`,
    ],
  },
  {
    name: "Enterprise",
    monthly: "",
    annual: "",
    monthly_id: "",
    annual_id: "",
    credits: 2400,
    benefits: [
      `Everything in Pro and...`,
      `\u2713 Generative Video Gen-3 Alpha`,
      `\u2713 Upscale resolution Gen-1, Gen-2`,
      `\u2713 Remove watermarks Gen-1, Gen2, Gen-3 Alpha`,
      `\u2713 Credits refresh monthly`,
      `\u2713 No rate restrictions`,
      `\u2713 Buy more credits`,
      `\u2713 Train custom IA`,
      `\u2713 1 complimentary training`,
      `\u2713 100GB Assets storage`,
      `\u2713 Unlimited video projects`,
      `\u2713 720p/4K/Alpha Matte Video project exports`,
      `\u2713 Technical support via Runway dashboard`,
    ],
  },
];

const Pricing = () => {
  const { get, post } = useApi();
  const [plans, setPlans] = useState(initialPlansDescription);
  // const stripe = useStripe();
  // const stripePromise = loadStripe();
  // const stripe = useStripe();
  // const elements = useElements();

  useEffect(() => {
    const fetchAsync = async () => {
      const result = await get("/webapp/pricing");

      const backendPlans = result["plans"];
      const updatedPlans = [...initialPlansDescription];

      backendPlans.forEach((plan) => {
        const planIndex = {
          Standard: 1,
          Pro: 2,
          Enterprise: 3,
        }[plan.name.split(" ")[0]]; // Mapea el nombre del plan al índice del array

        if (planIndex != null) {
          updatedPlans[planIndex].monthly = `$${plan.prices[0].price}`;
          updatedPlans[planIndex].annual = `$${plan.prices[1].price}`;
          updatedPlans[planIndex].monthly_id = plan.prices[0].price_id;
          updatedPlans[planIndex].annual_id = plan.prices[1].price_id;
        }
      });

      setPlans(updatedPlans);
    };
    fetchAsync();
  }, []);

  const buy = async (price_id) => {
    const stripeConfig = await get("/webapp/stripe/config");
    const stripe = await loadStripe(stripeConfig["publicKey"]);
    console.log(stripe);
    try {
      // Call backend to create a checkout session
      const session = await post("/webapp/stripe/create-checkout-session/", {
        price_id: price_id,
      });

      console.log(session);

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        sessionId: session["sessionId"],
      });

      if (error) {
        console.error("Error in redirecting to checkout:", error);
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };

  const [isAnnual, setIsAnnual] = useState(false);

  const handleToggle = () => setIsAnnual(!isAnnual);

  return (
    <>
      <div className={styles.planHeader}>
        <h2 className={styles.choosePlan}>Choose a plan</h2>

        <PricingToggle isAnnual={isAnnual} onToggle={handleToggle} />
      </div>

      <div className={styles.pricingSection}>
        <div className={styles.pricingCards}>
          {plans.map((plan) => (
            <PricingCard
              key={plan.name}
              title={plan.name}
              price={
                isAnnual ? `${plan.annual}/year` : `${plan.monthly}/monthly`
              }
              credits={plan.credits}
              benefits={plan.benefits}
              onClick={() => {
                if (isAnnual) {
                  buy(plan.annual_id);
                } else {
                  buy(plan.monthly_id);
                }
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Pricing;
